(function () {
  'use strict';

  var coverage = {
    'Distrito Nacional': ['Santo Domingo'],
    'Santo Domingo': ['Boca Chica', 'Boca Chica (La Caleta)', 'Los Alcarrizos (Palmarejo - Villa Linda)', 'Los Alcarrizos (Pantoja)', 'Pantoja (Los Alcarrizos)', 'Pedro Brand', 'Pedro Brand (La Guayiga)', 'Santo Domingo Este', 'Santo Domingo Este (San Luis)', 'Santo Domingo Norte', 'Santo Domingo Norte (La Victoria)', 'Santo Domingo Oeste (Engombe)'],
    'Azua': ['Azua (Azua de Compostela)', 'Azua (Clavellina)', 'Azua (Doña Emma Balaguer Viuda Vallejo)', 'Azua (Las barías)', 'Azua (Los Jovillos)', 'Estebanía', 'Sabana Yegua'],
    'Bahoruco': ['Galván', 'Neiba', 'Neiba (El Palmar)', 'Villa Jaragua'],
    'Barahona': ['Barahona (El Cachón)', 'Barahona (La Guázara)', 'Barahona (Santa Cruz de Barahona)', 'Barahona (Villa Central)', 'Cabral', 'El Peñón', 'Fundación', 'Fundación (Pescadería)', 'Jaquimeyes'],
    'Dajabón': ['Dajabón', 'Dajabón (Cañongo)', 'Loma de Cabrera', 'Loma de Cabrera (Santiago de la Cruz)'],
    'Duarte': ['San Francisco de Macoris (Duarte)', 'San Francisco de Macoris (Jaya)', 'San Francisco de Macoris (La Peña)', 'San Francisco de Macoris (Pdte. Don Antonio Guzmán)'],
    'El Seibo': ['El Seibo (Santa Cruz del Seibo)', 'El Seibo (Santa Lucía)'],
    'Elías Piña': ['Comendador'],
    'Espaillat': ['Cayetano Germosén (Guanábano)', 'Moca (Canca la Reyna)', 'Moca (El Higüerito)', 'Moca (Juan López)', 'Moca (La Ortega)', 'Moca (Las Lagunas)', 'Moca (Monte de la Jagua)', 'Moca (Pueblo Arriba)', 'San Víctor'],
    'Hato Mayor': ['Hato Mayor (Guayabo Dulce)', 'Hato Mayor (Hato Mayor del Rey)', 'Hato Mayor (Mata Palacio)', 'Hato Mayor (Yerba Buena)'],
    'Hermanas Mirabal': ['Salcedo (Juana Núñez)', 'Tenares'],
    'Independencia': ['Jimaní', 'Jimaní (Boca de Cachón)', 'Jimaní (El Limón)'],
    'La Altagracia': ['Higüey (Bávaro)', 'Higüey (La Otra Banda)', 'Higüey (Punta Cana)', 'Higüey (Salvaleón de Higüey)', 'Higüey (Verón)'],
    'La Romana': ['La Romana', 'La Romana (Caleta)', 'Villa Hermosa'],
    'La Vega': ['Jarabacoa', 'Jarabacoa (Buena Vista)', 'La Vega (Concepción de la Vega)', 'La Vega (Río Verde Arriba)'],
    'María Trinidad Sánchez': ['El Factor', 'Nagua', 'Nagua (Arroyo Al Medio)', 'Nagua (San José de Matanzas)'],
    'Monseñor Nouel': ['Bonao', 'Bonao (Arroyo Toro-Masipedro)', 'Bonao (Jayaco)', 'Bonao (Juma Bejucal)', 'Bonao (La Salvia)', 'Bonao (Sabana del Puerto)', 'Piedra Blanca', 'Piedra Blanca (Villa de Sonador)'],
    'Monte Cristi': ['Monte Cristi (San Fernando de Monte Cristi)', 'Villa Vásquez (Santa Ana, Villa Isabel)'],
    'Monte Plata': ['Monte Plata', 'Sabana Grande de Boyá'],
    'Pedernales': ['Pedernales', 'Pedernales (José Francisco Peña Gómez)'],
    'Peravia': ['Baní', 'Baní (Catalina)', 'Baní (Paya)', 'Baní (Villa Sombrero)', 'Matanzas'],
    'Puerto Plata': ['Puerto Plata (San Felipe de Puerto Plata)', 'Sosúa', 'Villa Montellano (Ingenio Montellano)'],
    'Samaná': ['Las Terrenas', 'Samaná (Santa Bárbara de Samaná)', 'Sánchez'],
    'San Cristóbal': ['Bajos De Haina (El Carril)', 'Bajos De Haina (Haina)', 'San Cristobal (Hato Damas)', 'San Cristóbal', 'San Gregorio De Nigua (Nigua Norte 1)', 'Villa Altagracia'],
    'San José de Ocoa': ['Sabana Larga', 'San José de Ocoa', 'San José de Ocoa (El Naranjal)'],
    'San Juan': ['Juan de Herrera', 'San Juan de La Maguana', 'San Juan de la Maguana (El Rosario)', 'San Juan de la Maguana (Hato del Padre)'],
    'San Pedro de Macorís': ['Consuelo', 'San Pedro de Macorís'],
    'Sánchez Ramírez': ['Cotuí', 'Cotuí (Quita Sueño)', 'La Mata', 'Villa La Mata (La Bija)'],
    'Santiago': ['Licey al Medio', 'Licey al Medio (Las Palomas)', 'Puñal', 'Puñal (Canabacoa)', 'Puñal (Guayabal)', 'Santiago (Santiago de los caballeros)', 'Tamboril (Canca La Piedra)', 'Tamboril (Peña)', 'Villa González'],
    'Santiago Rodríguez': ['San Ignacio de Sabaneta', 'Villa Los Almácigos'],
    'Valverde': ['Esperanza', 'Esperanza (Boca de Mao)', 'Laguna Salada (Jaibón)', 'Mao (Santa Cruz de Mao)', 'Mao (Ámina)']
  };

  var provinceOrder = ['Distrito Nacional', 'Santo Domingo'].concat(
    Object.keys(coverage).filter(function (name) {
      return name !== 'Distrito Nacional' && name !== 'Santo Domingo';
    }).sort(function (a, b) { return a.localeCompare(b, 'es'); })
  );
  var inputSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
  var activeProvinceInput = null;
  var activeCityInput = null;

  function setOriginal(input, value) {
    if (input.value === value) return;
    inputSetter.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function option(value, label) {
    var item = document.createElement('option');
    item.value = value;
    item.textContent = label;
    return item;
  }

  function styleLikeInput(select, input) {
    var style = window.getComputedStyle(input);
    ['backgroundColor', 'border', 'borderRadius', 'boxShadow', 'color', 'fontFamily', 'fontSize', 'fontWeight', 'height', 'letterSpacing', 'lineHeight', 'padding'].forEach(function (property) {
      select.style[property] = style[property];
    });
    select.style.width = '100%';
    select.style.boxSizing = 'border-box';
    select.style.cursor = 'pointer';
    select.style.colorScheme = 'dark';
  }

  function makeSelect(input, id, prompt) {
    var select = document.createElement('select');
    select.id = id;
    select.className = 'rsi-coverage-select';
    select.setAttribute('aria-label', prompt);
    select.required = true;
    styleLikeInput(select, input);
    select.appendChild(option('', prompt));
    input.style.position = 'absolute';
    input.style.width = '1px';
    input.style.height = '1px';
    input.style.opacity = '0';
    input.style.pointerEvents = 'none';
    input.style.padding = '0';
    input.style.border = '0';
    input.tabIndex = -1;
    input.setAttribute('aria-hidden', 'true');
    input.parentNode.appendChild(select);
    return select;
  }

  function populateCities(select, province, selected) {
    select.replaceChildren(option('', province ? 'Selecciona tu municipio / sector' : 'Primero selecciona una provincia'));
    (coverage[province] || []).forEach(function (name) { select.appendChild(option(name, name)); });
    select.disabled = !province;
    select.value = (coverage[province] || []).indexOf(selected) !== -1 ? selected : '';
  }

  function setup() {
    var provinceInput = document.querySelector('input#province[name="province"]');
    var cityInput = document.querySelector('input#city[name="city"]');
    if (!provinceInput || !cityInput || !provinceInput.isConnected || !cityInput.isConnected) return;
    var provinceWrapper = provinceInput.closest('.rsi-text-input-wrapper');
    var cityWrapper = cityInput.closest('.rsi-text-input-wrapper');
    if (!provinceWrapper || !cityWrapper) return;

    if (activeProvinceInput !== provinceInput || activeCityInput !== cityInput) {
      activeProvinceInput = provinceInput;
      activeCityInput = cityInput;
    }

    var provinceSelect = provinceWrapper.querySelector('#rsi-coverage-province');
    var citySelect = cityWrapper.querySelector('#rsi-coverage-city');
    if (!provinceSelect) {
      provinceSelect = makeSelect(provinceInput, 'rsi-coverage-province', 'Selecciona tu provincia');
      provinceOrder.forEach(function (name) { provinceSelect.appendChild(option(name, name)); });
      provinceSelect.value = coverage[provinceInput.value] ? provinceInput.value : '';
      var provinceLabel = provinceWrapper.querySelector('label[for="province"]');
      if (provinceLabel) provinceLabel.htmlFor = provinceSelect.id;
    }
    if (!citySelect) {
      citySelect = makeSelect(cityInput, 'rsi-coverage-city', 'Selecciona tu municipio / sector');
      var cityLabel = cityWrapper.querySelector('label[for="city"]');
      if (cityLabel) { cityLabel.htmlFor = citySelect.id; cityLabel.childNodes[0].textContent = 'Municipio / Sector'; }
      var helper = document.createElement('small');
      helper.id = 'rsi-coverage-help';
      helper.style.cssText = 'display:block;margin:7px 0 0;font-size:12px;line-height:1.45;color:#c7c7c7';
      helper.appendChild(document.createTextNode('¿No aparece tu municipio? Escríbenos por WhatsApp al '));
      var link = document.createElement('a');
      link.href = 'https://wa.me/18096244458';
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = '(809) 624-4458';
      link.style.cssText = 'color:inherit;text-decoration:underline';
      helper.appendChild(link);
      helper.appendChild(document.createTextNode(' y te decimos dónde podemos entregarte.'));
      cityWrapper.appendChild(helper);
      populateCities(citySelect, provinceSelect.value, cityInput.value);
    }
    if (!provinceSelect.dataset.coverageBound) {
      provinceSelect.dataset.coverageBound = '1';
      provinceSelect.addEventListener('change', function () {
        setOriginal(provinceInput, this.value);
        setOriginal(cityInput, '');
        populateCities(citySelect, this.value, '');
        citySelect.focus();
      });
    }
    if (!citySelect.dataset.coverageBound) {
      citySelect.dataset.coverageBound = '1';
      citySelect.addEventListener('change', function () { setOriginal(cityInput, this.value); });
    }
  }

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; setup(); });
  });
  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
    setup();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
